import "core-js/modules/es.array.slice.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-90f80136"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "bar"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("首页");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_fold = _resolveComponent("fold");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

  var _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_breadcrumb, {
    separator: ""
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_breadcrumb_item, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            onClick: $options.hides,
            type: "text"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_icon, {
                size: 30,
                class: _normalizeClass($data.xuan ? 'actives' : 'active')
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_fold, {
                    style: {
                      "color": "#999"
                    }
                  })];
                }),
                _: 1
              }, 8, ["class"])];
            }),
            _: 1
          }, 8, ["onClick"])];
        }),
        _: 1
      }), _createVNode(_component_el_breadcrumb, {
        "separator-icon": $setup.ArrowRight
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_breadcrumb_item, {
            to: {
              path: '/index/home'
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 1
          }), _ctx.$route.path != '/index/home' ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(_ctx.$route.matched.slice(1), function (item, index) {
            return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
              key: index
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.meta.title), 1)];
              }),
              _: 2
            }, 1024);
          }), 128)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["separator-icon"])];
    }),
    _: 1
  })]);
}